import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { AggCalcTrxViewer } from '@/gp/entities/calc/aggCalc/AggCalcTrxViewer';
import { CalcTrxValViewer } from '@/gp/entities/calc/aggCalc/CalcTrxValViewer';
import { CalcProdPpTrxViewer } from '@/gp/entities/calc/calcProdPp/CalcProdPpTrxViewer';
import { CalcProdCompare } from '@/gp/entities/calc/compare/CalcProdCompare';
import { CalcProdResCompare } from '@/gp/entities/calc/compare/CalcProdResCompare';
import { Route } from 'react-router-dom';
import { AggCalcTrxLookupViewer } from './entities/calc/aggCalc/AggCalcTrxLookupViewer';
import { CalcDashboard } from './entities/calc/dashboard/CalcDashboard';
import { ReallocTrxViewer } from './entities/calc/reallocRatio/ReallocTrxViewer';
import { IncRuleTreeList } from './entities/incRule/IncRuleTreeList';
import { IncDataSrcCompare } from './entities/pol/compare/IncDataSrcCompare';
import { PolFormulaCompare } from './entities/pol/compare/PolFormulaCompare';

const gpRoutes = [
  <Route path="/gp/calc/:calcEntity" element={<EntityView />} />,
  <Route path="/gp/calc" element={<EntityView />} />,
  <Route path="/gp/calc-prod" element={<EntityView />} />,
  <Route path="/gp/calc-prod-res" element={<EntityView />} />,
  <Route path="/gp/calc-dashboard" element={<CalcDashboard />} />,
  <Route path="/gp/pol" element={<EntityView />} />,
  <Route path="/gp/inc-data-src" element={<EntityView />} />,
  <Route path="/gp/inc-list" element={<EntityView />} />,
  <Route path="/gp/inc-rule" element={<EntityView />} />,
  <Route path="/gp/inc-cond" element={<EntityView />} />,
  <Route path="/gp/pol-formula" element={<EntityView />} />,
  <Route path="/gp/calc-trx-ovrd" element={<EntityView />} />,
  <Route path="/gp/compare/pol-formula" element={<PolFormulaCompare />} />,
  <Route path="/gp/compare/inc-data-src" element={<IncDataSrcCompare />} />,
  <Route path="/gp/compare/calc-prod" element={<CalcProdCompare />} />,
  <Route path="/gp/compare/calc-prod-res" element={<CalcProdResCompare />} />,
  <Route path="/gp/agg-viewer" element={<AggCalcTrxViewer />} />,
  <Route path="/gp/agg-lookup-viewer" element={<AggCalcTrxLookupViewer />} />,
  <Route path="/gp/inc-rule-tree" element={<IncRuleTreeList />} />,
  <Route path="/gp/val-viewer" element={<CalcTrxValViewer />} />,
  <Route path="/gp/pp-viewer" element={<CalcProdPpTrxViewer />} />,
  <Route path="/gp/realloc-viewer" element={<ReallocTrxViewer />} />
]

export default gpRoutes;